import { ProSelect } from '@bedrock/eed-react';
import { FC } from 'react';
import { ProSelectProps } from '@bedrock/eed-react/lib/components/ProForm/ProFormField/ProSelect';
import React from 'react';
import { EllipsisTags } from '@mpc/components';

export const ProTagSelect: FC<ProSelectProps> = (props) => {
  const render = (value: any) => {
    if (value && Array.isArray(value)) {
      return (
        <EllipsisTags
          value={value}
          tagProps={{
            color: 'light-grey',
          }}
          popoverContentClassName="max-w-[250px]"
        />
      );
    }
    if (value && value.name && value.value) {
      return (
        <EllipsisTags
          value={[value]}
          tagProps={{
            color: 'light-grey',
          }}
          popoverContentClassName="max-w-[250px]"
        />
      );
    }
    return <div>{value || '-'}</div>;
  };

  return <ProSelect {...props} render={render} />;
};
